import { Dialog } from '@material-ui/core';
import React, { useState, ReactElement } from 'react';
import { useStyles } from './styles';

interface ModalDropdownContainerProps {
  children: ReactElement;
  placeHolderTitle: string;
  isSmallerModal?: boolean;
  handleClick?: () => void;
  disabled?: boolean;
  fullHeight?: boolean;
}

export default function ModalDropdownContainer({
  children,
  placeHolderTitle,
  isSmallerModal = false,
  handleClick,
  disabled,
  fullHeight,
}: ModalDropdownContainerProps): JSX.Element {
  const classes = useStyles({ fullHeight });
  const [title, setTitle] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <button
        className={`${classes.dropdown} ${disabled && classes.dropdownDisabled} ${
          classes.modalDropdown
        }`}
        onClick={(): void => {
          if (!disabled) {
            setIsModalOpen(true);
            handleClick?.();
          }
        }}
      >
        <div className={classes.dropdownTitle}>{title || placeHolderTitle}</div>
        <div className={classes.chevron} />
      </button>

      <Dialog
        open={isModalOpen}
        onClose={(): void => {
          setIsModalOpen(false);
        }}
        PaperProps={{
          classes: {
            root: isSmallerModal ? '' : classes.dialog,
          },
        }}
      >
        {React.cloneElement(children, {
          onListItemClick: (value: string) => setTitle(value),
          setIsModalOpen,
        })}
      </Dialog>
    </>
  );
}
